/**
 * @generated SignedSource<<b18328ece2e42ac53eb958e2da5f0888>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SpacePostPolicy = "ALLOWED" | "RESTRICTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type createPostButtonFragment$data = {
  readonly postPolicy: SpacePostPolicy;
  readonly slug: string;
  readonly " $fragmentType": "createPostButtonFragment";
};
export type createPostButtonFragment$key = {
  readonly " $data"?: createPostButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"createPostButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "createPostButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postPolicy",
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": "__isSpace"
};

(node as any).hash = "a2648242157c5d864df8e46f02570ab8";

export default node;
